import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../features/auth";

interface IShowToastMessageActionPayload {
    messageTitle?: string;
    messageText: string;
    messageType?: 'success' | 'info' | 'warn' | 'error';
    windowType?: string;
}

interface IToastMessageSlice {
    toastMessageIsShown: boolean;
    toastMessageTitle?: string;
    toastMessageText: string;
    toastMessageType?: 'success' | 'info' | 'warn' | 'error';
    toastMessageWindowType?: 'map' | 'panorama' | 'card';
    toastMessageContainerClearButtonIsClicked: boolean;
}

function getInitialState() {
    const initialState: IToastMessageSlice = {
        toastMessageIsShown: false,
        toastMessageTitle: undefined,
        toastMessageText: "",
        toastMessageType: undefined,
        toastMessageWindowType: undefined,
        toastMessageContainerClearButtonIsClicked: false
    };
    return initialState
}

export const toastMessageSlice = createSlice({
    name: "toastMessage",
    initialState: getInitialState(),
    reducers: {
        showToastMessage(state, action: PayloadAction<IShowToastMessageActionPayload>) {
            const { messageTitle, messageText, messageType, windowType } = action.payload;
            state.toastMessageIsShown = true
            state.toastMessageTitle = messageTitle
            state.toastMessageText = messageText
            state.toastMessageType = messageType
            state.toastMessageWindowType = windowType
        },
        resetToastMessageSettings(state) {
            state.toastMessageIsShown = false
            state.toastMessageTitle = undefined
            state.toastMessageText = ""
            state.toastMessageType = undefined
            state.toastMessageWindowType = undefined
        },
        setToastMessageContainerClearButtonIsClicked(state, action: PayloadAction<any>) {
            state.toastMessageContainerClearButtonIsClicked = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState();
        });
    },
});

export const { showToastMessage, resetToastMessageSettings, setToastMessageContainerClearButtonIsClicked } = toastMessageSlice.actions;
export const toastMessageReducer = toastMessageSlice.reducer
